import React, { useEffect, useRef, useState } from "react";
import { addLeadingZero } from "../../../../utils/math";
import { BookmarkAdd, BookmarkFilled } from "@carbon/icons-react";
import { TRANSLATION_CONFIG } from "../../../../utils/consts/translation";
import { useTranslation } from "react-i18next";
import { ToolTip } from "../../../atom/Tooltip";
import { ParticipantExamQuestion } from "../../../../types/question";

interface QuestionItemProps {
  questions: ParticipantExamQuestion[];
  currentQuestion: number;
  flags: Record<number, boolean>;
  question: ParticipantExamQuestion;
  onSelectQuestion: (index: number) => void;
  index: number;
  toggleFlag: (questionNumber?: number) => void;
}

export const QuestionItem = ({
  flags,
  questions,
  currentQuestion,
  question,
  onSelectQuestion,
  index,
  toggleFlag,
}: QuestionItemProps) => {
  const { t } = useTranslation(TRANSLATION_CONFIG.appNamespace);
  const [isTooltipVisible, setTooltipVisible] = useState(false);

  const isSelected = index === currentQuestion;
  const filledFlag = flags[questions[index]?.id];

  const itemRef = useRef<HTMLLIElement | null>(null);

  useEffect(() => {
    if (isSelected && itemRef.current) {
      itemRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [isSelected]);

  const exam_question = question?.exam_question;

  return (
    <li
      ref={itemRef}
      onClick={() => onSelectQuestion(index)}
      className={`group flex items-center justify-between p-3 cursor-pointer text-center transition-colors ${
        isSelected ? "bg-ominimo-400-transparent" : "bg-white"
      }`}>
      <div className="flex justify-between items-center w-full">
        <div className="flex items-center gap-x-2">
          <p
            className={`text-center font-outfit text-[18px] font-normal leading-[1.4] tracking-[2px] [font-variant-numeric:lining-nums_tabular-nums] p-4 transition-colors ${
              isSelected ? "text-ominimo-400" : "text-gray-550"
            } group-hover:bg-ominimo-400-transparent group-hover:rounded-full`}>
            {addLeadingZero(index + 1)}
          </p>
          <p
            className={`overflow-hidden max-w-[348px] text-ellipsis text-[14px] font-medium leading-[1.4] tracking-[0.25px] text-left line-clamp-2 group-hover:text-black ${
              isSelected ? "text-black" : "text-gray-375"
            }`}>
            {exam_question?.question_text}
          </p>
        </div>

        <div className="flex items-center space-x-2 pr-3">
          <div
            className="cursor-pointer relative"
            onMouseEnter={() => setTooltipVisible(true)}
            onMouseLeave={() => setTooltipVisible(false)}
            onClick={() => toggleFlag(index)}>
            {filledFlag ? (
              <BookmarkFilled size={20} className="text-red-450" />
            ) : (
              <BookmarkAdd size={20} className="text-gray-376 hover:text-blue-750" />
            )}
            {isTooltipVisible && <ToolTip text={t("Answer this question later.")} />}
          </div>
        </div>
      </div>
    </li>
  );
};
